import { DODA_SITE_URL } from '@doda/common/src/constants/urls';

export const CONDITION_CHANGE_LINK = {
  LOGIN_STATE_LINK: DODA_SITE_URL.jobSearchTop,
  LOGOUT_STATE_LINK: DODA_SITE_URL.jobSearchTop,
};

export const JOB_SEARCH_LIST_LINK = {
  CONDITION_CHANGE_USRCLK:
    'usrclk_searchList=PC-%sJobSearchList_searchConditionArea_currentSearchConditions_changeSearchConditions',
  LOGIN_PAGE_LINK: `/dcfront/login/login/?usrclk_searchList=PC-logoutJobSearchList_searchConditionArea_currentSearchConditions_saveSearchConditions`,
  SAVED_SEARCH_BUTTON_USRCLK:
    'PC-%sJobSearchList_searchConditionArea_currentSearchConditions_saveSearchConditions',
} as const;

export const MATCH_JOB_LIST_LINK = {
  LOGIN_PAGE_LINK: `/dcfront/login/login`,
} as const;

export const MAX_SAVED_COUNT = 5;
